import { useEffect, useRef, useState } from "react";
import { uploadFilesToFilestorage } from "../utils/media-files";
import { addOrUpdateGroupId, deleteDocumentRequest, getListOfFiles } from "../api/fileStorage";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { FileStorageS10Data } from "../interfaces/fileStorage.interface";
import MyTable, { TableRow } from "./MyTable";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton } from "@mui/material";

import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';


import {ReactComponent as FileIcon} from '../assets/images/mi-portal/my-file/file.svg';
import { TableHeadRows } from "./MyTable/TableHead";
import DownloadButtonDocument from "../views/my-potal/documents/downloadButtonDocument";
import { CONTRACT_DOCUMENT_SIGNATURE_REQUEST } from "../constants/signalRequestConsts";
import MyTextField from "./MyTextField";
import MyDatepicker from "./my-datepicker";
import dayjs from "dayjs";

interface DocumentsComponentProps {
    groupId?: string;
    allowToDeleteFiles: boolean;
    allowToAddFiles: boolean;
    afterDeleteFileAction?: (deletedFileId: string, remainingFiles: number) => Promise<void>;
    afterUploadFileAction?: (uploadedFile: File[], remainingFiles: number) => Promise<void>;
}

export const DocumentsComponent = ({groupId, allowToDeleteFiles, allowToAddFiles, afterDeleteFileAction, afterUploadFileAction}: DocumentsComponentProps) => {

    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const [loading, setLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [fileIdToDelete, setFileIdToDelete] = useState<string>();
    const [userFiles, setUserFiles] = useState<FileStorageS10Data[]>([]);

    
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleCloseModal = () => {
        // setSelectedFiles([]);
        setOpenModal(false);
    }

    const handleGetFiles = async () => {
        setLoading(true);
        const result = await getListOfFiles(groupId || (companyselected as any)?.Code);
        setUserFiles(result || []);
        setLoading(false);
    }

    useEffect(() => {
        if (!companyselected?.Token || !connectionId || loading) {
            return;
        }
        handleGetFiles();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected?.Token, connectionId, groupId]);

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files as any;
    
        if (!files) return;
        setSelectedFiles([])
        const result = await uploadFilesToFilestorage(files, () => {}, false, (groupId || companyselected?.Code));
        if (result === null) {
            setLoading(false);
            return;
        }
        const filestorageData = result.filestorageData
                                .map(f => ({
                                    ...f, 
                                    Folder: groupId ? "" : "Documentos Relacionados",
                                    RUCCorporation: companyselected?.RUC as any
                                }));
        const updateGroupId = await addOrUpdateGroupId(filestorageData);
        if (updateGroupId?.Type !== 0) {
            setLoading(false);
            return;
        }
        if (afterUploadFileAction) await afterUploadFileAction(files, userFiles.length);
        await handleGetFiles();
    };

    const handleTriggerButtonClick = () => {
        fileInputRef.current?.click();
    };

    const handleDeleteFileFromFS = async () => {
        if (!fileIdToDelete) {
            return;
        }
        setLoading(true)
        console.log(fileIdToDelete)
        await deleteDocumentRequest(fileIdToDelete);
        await handleGetFiles();
        setFileIdToDelete("");
        if (afterDeleteFileAction) {
            await afterDeleteFileAction(fileIdToDelete, userFiles.length)
        }
        setLoading(false)
    }

    const handleDeleteFile = (file: File) => {
        const newItems = selectedFiles.filter(f => f !== file);
        setSelectedFiles(newItems);
    }
    
    return (<>
        <MyTable
            key="tab-0"
            tableHeadRows={[
                {
                    label: "Nombre",
                    rowKeyName: "FileName",
                    customValue: (_head: any, row: any) => {
                        return (
                            <Grid container alignItems="center">
                                <Grid item style={{marginRight: ".5rem"}}>
                                    <FileIcon/>
                                </Grid>
                                {row.FileName}
                            </Grid>
                        )
                    },
                },{
                    label: "Tipo",
                    rowKeyName: "Extention",
                },{
                    label: "Fecha",
                    rowKeyName: "Date",
                }, {
                    label: "",
                    rowKeyName: "viewFile",
                    customValue: (headRow: TableHeadRows, row: TableRow<string, any>) => {
                        return (
                            
                        <Grid container direction="row" minWidth="5rem">
                            {allowToDeleteFiles && <Grid item style={{marginRight: ".5rem", width: "2rem", height: "2rem"}}>
                                <IconButton
                                    aria-label="Eliminar"
                                    onClick={async () => {
                                        setFileIdToDelete(row.Id)
                                    }}
                                    style={{
                                        minWidth: "2rem",
                                        minHeight: "2rem",
                                        padding: ".25rem",

                                        lineHeight: "1.25rem", 
                                    }}
                                >
                                    <DeleteRoundedIcon color="error" />
                                </IconButton>
                            </Grid>}
                            <Grid item width="2.5rem" height="2rem">
                                <DownloadButtonDocument
                                    FirmadoFecha={""}
                                    IdDocument={""}
                                    FirmaTop={row.FirmaTop}
                                    NroFs={row.Id}
                                    requestId={CONTRACT_DOCUMENT_SIGNATURE_REQUEST}
                                />
                            </Grid>
                        </Grid>
                    )},
                }
            ]}
            tableRows={userFiles}
            loading={false}
            customItemOptionBar={() =>{
                if (!allowToAddFiles) {
                    return <></>;
                }
                return <Grid>
                    <Button
                        variant="outlined"
                        style={{
                            backgroundColor: "white",
                            fontSize: "14px",
                        }}
                        startIcon={<AddIcon />}
                        onClick={handleTriggerButtonClick}
                    >
                        Agregar
                    </Button>
                    <input 
                        type="file"
                        ref={fileInputRef} 
                        style={{ display: 'none' }}
                        onChange={handleFileChange}  
                        accept=".pdf,image/*"
                    />
                </Grid>
            }}
            hiddenBottomPaginator={true}
            hiddenItemsPerPage={true}
            hiddenSearchInput={true}
            onlyTable={false}
            tableOptionsBar={{
                useDrawer: false,
            }}
        />
        {fileIdToDelete && <Dialog
            open={true}
            aria-labelledby="responsive-dialog-title"
            style={{width: "100%"}}
        >
            <DialogTitle
                id="responsive-dialog-title" 
                style={{padding: "0", textAlign: "center"}} 
                variant="h5"
            >
                Eliminar archivo
            </DialogTitle>
            <DialogContent style={{width: "100%", textAlign: "center"}}>
            </DialogContent>
                <DialogTitle 
                    id="responsive-dialog-title" 
                    style={{padding: "0", textAlign: "center"}} 
                    variant="body1"
                >
                    ¿Seguro de eliminar el archivo?
                </DialogTitle>
            <DialogActions>
                <Grid container >
                    <Grid item xs={6}>
                        <Button 
                            variant="outlined" 
                            style={{width: "8rem", margin: ".5rem",}}
                            startIcon={<CloseIcon style={{height: "1rem"}} />}
                            onClick={() => setFileIdToDelete("")}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                    <Grid item xs={6} textAlign={"right"}>
                        <Button 
                            variant="contained"
                            color="error"
                            style={{width: "8rem", margin: ".5rem",}}
                            startIcon={<CheckIcon style={{height: "1rem"}} />}
                            onClick={handleDeleteFileFromFS}
                        >
                            Eliminar
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>}
        <Dialog
            open={openModal}
            aria-labelledby="responsive-dialog-title"
            style={{width: "100%"}}
        >
            <DialogTitle 
                id="responsive-dialog-title" 
                style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                variant="h5"
            >
                Registro
            </DialogTitle>
            <DialogContent style={{width: "100%", textAlign: "center"}}>
                <Grid container spacing="1.5rem">
                    <Grid item xs={12}>
                        <MyTextField style={{width: "100%"}} label="Tipo de capacitación**" />
                    </Grid>
                    <Grid item xs={12}>
                        <MyTextField style={{width: "100%"}} label="Centro de estudios**" />
                    </Grid>
                    <Grid item xs={12}>
                        <MyTextField style={{width: "100%"}} label="Nombre de la capacitación**" />
                    </Grid>
                    <Grid item xs={6}>
                        <MyDatepicker
                            labelText="Fecha de inicio"
                            maxDate={dayjs()}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <MyDatepicker 
                            labelText="Fecha de fin"
                            maxDate={dayjs()}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            variant="outlined"
                            style={{
                                backgroundColor: "white",
                                fontSize: "14px",
                            }}
                            startIcon={<AddIcon />}
                            onClick={handleTriggerButtonClick}
                        >
                            Agregar documento relacionado
                        </Button>
                        <input 
                            type="file"
                            ref={fileInputRef} 
                            style={{ display: 'none' }}
                            onChange={handleFileChange} 
                            multiple 
                            accept=".pdf" 
                        />

                    </Grid>

                    <Grid item xs={12}>
                    {selectedFiles?.length > 0 && <MyTable
                        key={`tab-${selectedFiles.length}`}
                        tableHeadRows={[{
                                label: "Nombre",
                                rowKeyName: "name",
                                customValue: (_head: any, row: any) => {
                                    return (
                                        <Grid container alignItems="center">
                                            <Grid item style={{marginRight: ".5rem"}}>
                                                <FileIcon/>
                                            </Grid>
                                            {row.name}
                                        </Grid>
                                    )
                                },
                            },{
                                label: "Tipo",
                                rowKeyName: "type",
                            },{
                                label: "",
                                rowKeyName: "Actions",
                                customValue: (_head: any, row: any) => {
                                    return (
                                        <Button 
                                            variant="outlined" 
                                            color="error"
                                            style={{
                                                padding: ".5rem", 
                                                lineHeight: "1.25rem", 
                                                backgroundColor: "#F8E6E6",
                                                minWidth: "auto"
                                            }}
                                            onClick={() => {
                                                handleDeleteFile(row as any)
                                            }}
                                        >  
                                            <DeleteRoundedIcon/>
                                        </Button>
                                    )
                                },
                            },
                        ]}
                        tableRows={selectedFiles}
                        loading={false}
                        onlyTable={true}
                        tableOptionsBar={{
                            useDrawer: true,
                        }}
                    />}
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                    <Grid item xs={6}>
                        <Button 
                            variant="outlined" 
                            style={{width: "8rem"}}
                            startIcon={<CloseIcon style={{height: "1rem"}} />}
                            onClick={handleCloseModal}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                    <Grid item xs={6} textAlign={"right"}>
                        <Button 
                            variant="contained" 
                            style={{width: "8rem"}}
                            startIcon={<CheckIcon style={{height: "1rem"}} />}
                            onClick={handleCloseModal}
                        >
                            Aceptar
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    </>)
}